import { DocumentDto } from '@ecdlink/core';
import { createSelector } from 'reselect';
import { RootState } from '../types';

/* -------------------------------
   Base Selectors (primitives)
-------------------------------- */

const selectDocuments = (state: RootState) =>
  state.documents.documentsForHCW ?? [];

export const getDocumentByTypeId = (userId?: string, typeId?: string) =>
  createSelector(
    (state: RootState) => state.documents.documentsForHCW,
    (documents: DocumentDto[] | undefined) => {
      if (!documents || !userId || !typeId) return;

      return documents.find(
        (document) =>
          document.userId === userId && document.documentTypeId === typeId
      );
    }
  );

export const getDocumentsByUserId = (userId: string) =>
  createSelector(
    (state: RootState) => state.documents.documentsForHCW,
    (documents: DocumentDto[] | undefined) => {
      if (!documents || !userId) return;

      return documents.filter((document) => document.userId === userId);
    }
  );

export const getDocumentsToSync = createSelector([selectDocuments], (mothers) =>
  mothers.filter((item) => 'synced' in item && item.synced === false)
);
